import LanguageIcon from "@mui/icons-material/Language";
import { Button, ListItem, FormControl, Checkbox, DialogTitle, DialogContent, Dialog, DialogActions, FormControlLabel } from "@mui/material";
import React, { useState } from "react";

export function LanguagePicker(props) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const selectedLanguagesText = props.selectedLanguages
    .map((code) => code)
    .join(", ");

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        startIcon={<LanguageIcon />} // Assuming LanguageIcon is an icon component
        onClick={handleOpen}
        sx={{
          overflow: "hidden",
          backgroundColor: "white",
          color: "inherit",
          maxWidth: "100%", // Restricting the width to 100%
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "flex", // Ensures that flex properties work
        }}
      >
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {selectedLanguagesText || "Select Language"}
        </span>
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        sx={{ maxHeight: "80vh" }}
      >
        <DialogTitle id="language-picker-dialog-title">
          Select Languages
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            {props.languageList.map((language) => (
              <ListItem key={language.code} disablePadding>
                <FormControlLabel
                  control={<Checkbox
                    checked={props.selectedLanguages.includes(language.code)}
                    onChange={(e) => {
                      const selected = props.selectedLanguages.includes(
                        language.code
                      )
                        ? props.selectedLanguages.filter(
                          (code) => code !== language.code
                        )
                        : [...props.selectedLanguages, language.code];
                      props.setSelectedLanguages(selected);
                    } } />}
                  label={`${language.code} - ${language.name}`} />
              </ListItem>
            ))}
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}


export default LanguagePicker;